import { ColumnDef } from '@tanstack/react-table';
import { DataTable } from '@/components/common/DataTable';
import { PlayerProfitLoss } from '@/types';
import { exportCSV } from '@/utils/exportCSV';

export default function PlayerProfitLossPage() {
  const columns: ColumnDef<PlayerProfitLoss>[] = [
    { accessorKey: 'playerId', header: 'Player ID' },
    { accessorKey: 'username', header: 'Username' },
    {
      accessorKey: 'totalBet',
      header: 'Total Bet',
      cell: ({ row }) => `₹${row.original.totalBet}`,
    },
    {
      accessorKey: 'totalWin',
      header: 'Total Win',
      cell: ({ row }) => `₹${row.original.totalWin}`,
    },
    {
      accessorKey: 'totalLoss',
      header: 'Total Loss',
      cell: ({ row }) => `₹${row.original.totalLoss}`,
    },
    {
      accessorKey: 'net',
      header: 'Net',
      cell: ({ row }) => {
        const net = row.original.net;
        return <span className={net >= 0 ? 'text-green-500' : 'text-red-500'}>₹{net}</span>;
      },
    },
  ];

  const data: PlayerProfitLoss[] = [
    {
      playerId: 'USR101',
      username: 'Rahul',
      totalBet: 15000,
      totalWin: 8000,
      totalLoss: 7000,
      net: 1000,
    },
    {
      playerId: 'USR102',
      username: 'Amit',
      totalBet: 20000,
      totalWin: 5000,
      totalLoss: 15000,
      net: -10000,
    },
  ];

  const handleExport = (rows: PlayerProfitLoss[]) => {
    exportCSV({
      filename: 'player_profit_loss.csv',
      header: ['Player ID', 'Username', 'Total Bet', 'Total Win', 'Total Loss', 'Net'],
      rows: rows.map((p) => [p.playerId, p.username, p.totalBet, p.totalWin, p.totalLoss, p.net]),
    });
  };

  return (
    <>
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Player Performance (Profit / Loss)</h2>
          <p className="text-muted-foreground">
            See how much each player has won or lost overall. Useful for identifying high-value
            players, risky users, or unusual gameplay trends.
          </p>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        enableSelection={true}
        enableExport={true}
        onExport={handleExport}
        searchPlaceholder="Search player..."
        pageIndex={0}
        total={0}
        onPageChange={function (page: number): void {
          throw new Error('Function not implemented.');
        }}
        onPageSizeChange={function (size: number): void {
          throw new Error('Function not implemented.');
        }}
      />
    </>
  );
}
